import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[wlevel2,setLevelw2]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[b17,setb17]=useState("None");
const[b18,setb18]=useState("None");
const[b19,setb19]=useState("None");
const[b20,setb20]=useState("None");
const[b21,setb21]=useState("None");
const[b22,setb22]=useState("None");
const[b23,setb23]=useState("None");
const[b24,setb24]=useState("None");
const[b25,setb25]=useState("None");
const[b26,setb26]=useState("None");

const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");

// ===== SLIDER STATE =====
const [current, setCurrent] = useState(0);
const sliderTotal = 4;
const goTo = (n) => setCurrent((n + sliderTotal) % sliderTotal);

// ===== SLIDER AUTO-PLAY =====
useEffect(() => {
  const timer = setInterval(() => setCurrent(c => (c + 1) % sliderTotal), 5000);
  return () => clearInterval(timer);
}, []);

// ===== SLIDER TRACK SYNC =====
useEffect(() => {
  const track = document.getElementById('slider-track');
  if (track) {
    requestAnimationFrame(() => {
      track.style.transform = `translateX(-${current * 100}%)`;
    });
  }
}, [current]);
  useEffect(() => {
    const connectWallet = async () => {
    const contractAddress = "0x40BBA892E932b73e60c4A35b66cF77A41D27A5b1";
    const contractABI = abi.abi;
    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
   if(myParam == null)
     {
     document.querySelector("#name").value="0x9e1A761DC1d295D03B5D98565D80b6aa4FBf4659";
     }
    try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
       let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);
      var i = 0;
      document.querySelector("#us").value  = alltasks[13];

      const x5 = Number(alltasks1[2]);
      setx5(x5);

      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[5]);
      sea1(a1);
      const refer2 = (alltasks[23]);
      setrefer2(refer2);
      const x4 = Number(alltasks[19])/1000000000000000000;
      setx4(x4);
      
      document.querySelector("#hid").value  = (alltasks[1]);
      const direct =Number(alltasks[2]);
      setDirect(direct);
      const level = Number(alltasks[4]);
      setLevel(level);
     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     const pack = Number(alltasks[3]) ;
     setpackage(pack);
     document.querySelector("#pp").value  = Number(alltasks[3]);
     const b ='https://bscscan.com/address/'+account;
        
         setB(b);
     const dd = Number(alltasks[9]);
      setDD(dd);
      const reward1 = Number(alltasks[4]);
      setreward1(reward1);
      const reward2 = Number(alltasks[18]);
      setreward2(reward2);
      const reward3 = Number(alltasks[31])/1000000000000000000;
      setreward3(reward3);
      const reward4 =  Number(alltasks[29])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);
      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);
      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);
      const x1 = (Number(alltasks[17])/1000000000000000000).toFixed(2);
      setx1(x1);
      const x2 = (Number(alltasks[21])/1000000000000000000).toFixed(2);
      setx2(x2);
      const x3 = (Number(alltasks[19])/1000000000000000000).toFixed(2);
      setx3(x3);
      document.querySelector("#tt2").value = tt2;
      const b1 = Number(alltasks[8]) ;
      setb1(b1);
      const b2 = Number(alltasks[9]) ;
      setb2(b2);
      const b3 = Number(alltasks[10]) ;
      setb3(b3);
      const b4 = Number(alltasks[44])/1000000000000000000 ;
      setb4(b4);
      const b5 = (Number(alltasks[45])/1000000000000000000).toFixed(2);
      setb5(b5);
      const b6 = Number(alltasks[29])/1000000000000000000 ;
      setb6(b6);
      const b7 = Number(alltasks[5]) ;
      setb7(b7);
      const b8 = Number(alltasks[6]) ;
      setb8(b8);
      const b9 = Number(alltasks[7]) ;
      setb9(b9);
      const b10 = Number(alltasks[8]) ;
      setb10(b10);
      const b11 = Number(alltasks[9]) ;
      setb11(b11);
       const b12 = Number(alltasks[10]) ;
      setb12(b12);


       const b13 = Number(alltasks[30]) ;
      setb13(b13);
       const b14 = Number(alltasks[31]) ;
      setb14(b14);
       const b15 = Number(alltasks[32]) ;
      setb15(b15);
       const b16 = Number(alltasks[33]) ;
      setb16(b16);
       const b17 = Number(alltasks[34]) ;
      setb17(b17);
       const b18 = Number(alltasks[35]) ;
      setb18(b18);
       const b19 = Number(alltasks[36]) ;
      setb19(b19);
       const b20 = Number(alltasks[37]) ;
      setb20(b20);
       const b21 = Number(alltasks[38]) ;
      setb21(b21);
      const b22 = Number(alltasks[39]) ;
      setb22(b22);
      const b23 = Number(alltasks[40]) ;
      setb23(b23);
      const b24 = Number(alltasks[41]) ;
      setb24(b24);
      const b25 = Number(alltasks[42]) ;
      setb25(b25);
      const b26 = Number(alltasks[43]) ;
      setb26(b26);
      
 const wlevel = Number(alltasks[25]) ;
 setLevelw(wlevel);
 const wlevel1 = (Number(alltasks[15])/1000000000000000000).toFixed(2);
 setLevelw1(wlevel1);
 const wlevel2 = ((Number(alltasks[16])/1000000000000000000) + (Number(alltasks[15])/1000000000000000000)).toFixed(2);
 setLevelw2(wlevel2);
 const level1 = Number(alltasks[24]);
 setLevel1(level1);
 

     document.querySelector("#wi1").value =  Number(alltasks[15])/1000000000000000000;
     document.querySelector("#roi").value =  Number(alltasks[3]);
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
     const a3 = Number(alltasks[7]);
          
    sea3(a3);
     const a2 = Number(alltasks[6]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const tt =  (Number(alltasks[16])/1000000000000000000).toFixed(2);
     settt(tt);
     
const pack1 = ((Number(alltasks[16])/1000000000000000000) + (Number(alltasks[3]))).toFixed(2);

setpackage1(pack1);

     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://globalempire.live/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);


console.log(pack);

  const dd2 = Number(alltasks[25]?.toString?.() || alltasks[30]);
setDD2(dd2);

const dd1 = Math.floor(Date.now() / 1000);
setDD1(dd1);

// remaining seconds (24 hours)
const totalSeconds = Math.max(0, 86400 - (dd1 - dd2));

// convert to hh:mm:ss
const hours = Math.floor(totalSeconds / 3600);
const minutes = Math.floor((totalSeconds % 3600) / 60);
const seconds = totalSeconds % 60;

const formattedTime =
  String(hours).padStart(2, "0") + ":" +
  String(minutes).padStart(2, "0") + ":" +
  String(seconds).padStart(2, "0");

settt2(formattedTime);
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }
  document.body.style.backgroundColor = 'black';
  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
    <div className="app" id="app">
      <div className="main">
        <div className="topbar">
          <div className="topbar-left">
            <div className="burger" id="burger" title="Menu">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                strokeWidth="2.4"
                strokeLinecap="round"
              >
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </div>
          </div>

          <div className="brand">
            <img
              src="./logo.png"
              alt="Global Empire Logo"
              className="brand-logo-img"
            />
          </div>
        </div>

        <div className="content">
          <div className="page-head">
            <h1>Dashboard</h1>
            <div className="breadcrumb">
              <a href="#">Home</a> &nbsp;/&nbsp; Dashboard
            </div>
          </div>

          {/* Latest news marquee */}
          <div className="news">
            <div className="news-badge">LATEST NEWS</div>
            <div className="news-track-wrap">
              <div className="news-track">
                <span
                  ><i>📢</i> Pre Registration Get 100% Bonus on Investment</span
                >
                
                <span
                  ><i>🚀</i> Global Empire Staking features are now live on BNB
                  Smart Chain mainnet.</span
                >
                <span
                  ><i>💎</i>  Pre Registration Get 100% Bonus on Investment</span
                >
              </div>
            </div>
          </div>

          {/* Crypto ticker */}
          <div className="card span-full">
  <div className="referral-row">
    <div className="referral-ic">🔗</div>

    <div className="referral-copy">
      <h3>Your Referral Link</h3>
      <p>Share this link to invite others and earn rewards.</p>
    </div>
  </div>

  <div className="referral-input-row">
    <div style={{wordBreak:"break-all",fontSize:"0.8rem"}} st className="referral-field" id="refLink">
        {referlink} 
    </div>

      <button
              className="btn btn-teal"
                onClick={() => navigator.clipboard.writeText(referlink)}
              >
                Copy Link
              </button>

  
  </div>
</div>
            {/* Team stats */}
           <div className="wallet-container">

  <div className="wallet-box">
    <h3>Register</h3>
    <input
      id="amt" type="text"  placeholder="Enter amount" 
      className="wallet-input"
    />
    <Buy state={state} />
  </div>

  <div className="wallet-box">
    <h3>Withdrawal</h3>
    <input
     type="text" id="test" placeholder="Enter amount" 
      className="wallet-input"
    />
    <Buy3 state={state} />
  </div>

  <div className="wallet-box">
    <h3>Trade</h3>
    <input
     type="hidden" id="test"  placeholder="Enter amount" 
      className="wallet-input"
    />
    <Buy1 state={state} />
  </div>

  <div className="wallet-box">
    <h3>Next Trade in :</h3>
   <h2>{tt2}</h2>

</div>
</div>
            <br></br>
          
          {/* Main grid */}
          <div className="grid">
            {/* Referral */}
         

            {/* Challenge reward */}
           <div className="card challenge-card">
  <div className="challenge-tag">🚀 ABOUT US</div>
  <h2 className="challenge-title">BUILDING THE FUTURE OF DIGITAL GROWTH</h2>
  <p className="challenge-sub">
    Empowering users through innovation, transparency, and sustainable opportunities.
  </p>


              <div className="car-wrap">
                <img
                  src="./crypto_reward.jpg"
                  alt="Win Crypto Staking Vault Rewards"
                  className="challenge-img"
                />
              </div>

              <div className="progress-mini">
                
                <div className="bar-track">
                  <div className="bar-fill gold" style={{width: "92%"}}></div>
                </div>
              </div>
             

              <div className="split-3">
                <div className="seg">
                  <div style={{wordBreak:"break-all"}}  className="amt"> {wlevel2}</div>
                  <div className="lbl">Total Income</div>
                </div>
                <div className="seg">
                  <div className="amt">{pack1}</div>
                  <div className="lbl">My Fund value </div>
                </div>
                <div className="seg">
                  <div className="amt"> {b6}</div>
                  <div className="lbl">Reward</div>
                </div>
              </div>
            </div>
           
            {/* Team stats */}
            <div className="card">
              <div className="card-title">
                <span className="ic-wrap">👥</span> Income
              </div>
              <div className="stat-grid">
                 <div className="stat-box">
                  <div style={{fontSize:"1rem",wordBreak:"break-all"}}   className="num"> {wlevel2}</div>
                  <div className="lbl"> Total Income</div>
                </div>
               <div className="stat-box">
                  <div style={{fontSize:"1rem", wordBreak:"break-all"}} className="num">{b4} USDT</div>
                  <div className="lbl"> Direct Income</div>
                </div>
              
                <div className="stat-box">
                  <div style={{fontSize:"1rem",wordBreak:"break-all"}} className="num"> {b5} USDT</div>
                  <div className="lbl">Single Leg Income</div>
                </div>
                <div className="stat-box">
                  <div style={{fontSize:"1rem",wordBreak:"break-all"}} className="num">{x3}</div>
                  <div className="lbl"> Level Income</div>
                </div>
              
              </div>
            </div>

            {/* Quick stats */}
            <div className="card">
              <div className="card-title">
                <span className="ic-wrap">📊</span> Quick Stats
              </div>
              <div className="list-rows">
                <div className="row">
                  <span className="k">My Fund value</span
                  ><span className="v"> {pack1}</span>
                </div>
                <div className="row">
                  <span className="k">My Investment</span
                  ><span className="v">  {pack}</span>
                </div>
                <div className="row">
                  <span className="k">Total Income</span><span style={{wordBreak:"break-all"}} className="v "> {wlevel2}</span>
                </div>
                
                <div className="row">
                  <span className="k">My Investment</span
                  ><span className="v">{pack}</span>
                </div>
                <div className="row">
                  <span className="k">Pending Income</span
                  ><span className="v"> {tt} USDT</span>
                </div>
                <div className="row">
                  <span className="k"> Personal Growth Income</span
                  ><span className="v">{x1} USDT</span>
                </div>
                <div className="row">
                  <span className="k">Direct Income</span
                  ><span className="v">{b4} USDT</span>
                </div>
              </div>
            </div>

            {/* Team stats */}
            <div className="card">
              <div className="card-title">
                <span className="ic-wrap">👥</span> Team Overview
              </div>
              <div className="stat-grid">
                <div className="stat-box">
                  <div className="num"> {direct}</div>
                  <div className="lbl">Direct Team</div>
                </div>
                <div className="stat-box">
                  <div className="num">{level}</div>
                  <div className="lbl"> Level Team</div>
                </div>
              
              </div>
            </div>

            {/* Team business & today income */}
            <div className="card">
              <div className="card-title">
                <span className="ic-wrap">📈</span> Level Business 
               
              </div>
              <div className="list-rows">
                <div className="row">
                  <span className="k">Level 1 Business</span
                  ><span className="v">{b7} USDT</span>
                </div>
                <div className="row">
                  <span className="k">Level 2 Business</span
                  ><span className="v">{b8} USDT</span>
                </div>
                <div className="row">
                  <span className="k">Level 3 Business</span
                  ><span className="v ">{b9} USDT</span>
                </div>
                <div className="row">
                  <span className="k"> Level 4 Business</span
                  ><span className="v">{b10} USDT</span>
                </div>
                <div className="row">
                  <span className="k"> Level 5 Business</span
                  ><span className="v">{b11} USDT</span>
                </div>
                <div className="row">
                  <span className="k"> Level 6 Business</span
                  ><span className="v">{b12} USDT</span>
                </div>
                <div className="row">
                  <span className="k">Level 7 Business</span
                  ><span className="v">{b13} USDT</span>
                </div>
                <div className="row ">
                  <span className="k">Level 8 Business</span
                  ><span className="v">{b14} USDT</span>
                </div>
                <div className="row">
                  <span className="k"> Level 9 Business</span
                  ><span className="v">{b15} USDT</span>
                </div>
                <div className="row ">
                  <span className="k">Level 10 Business</span
                  ><span className="v">{b16} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k">Level 11 Business</span
                  ><span className="v">{b17} USDT</span>
                </div>
                 <div className="row">
                  <span className="k">Level 12 Business</span
                  ><span className="v">{b18} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k">Level 13 Business</span
                  ><span className="v">{b19} USDT</span>
                </div>
                 <div className="row">
                  <span className="k">Level 14 Business</span
                  ><span className="v">{b20} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k">Level 15 Business</span
                  ><span className="v">{b21} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k">Level 16 Business</span
                  ><span className="v">{b22} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k">Level 17 Business</span
                  ><span className="v">{b23} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k">Level 18 Business</span
                  ><span className="v">{b24} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k"> Level 19 Business</span
                  ><span className="v">{b25} USDT</span>
                </div>
                 <div className="row ">
                  <span className="k">Level 20 Business</span
                  ><span className="v">{b26} USDT</span>
                </div>
                
              </div>
            </div>

          
         

            {/* Income breakdown */}
            <div className="card span-full">
              <div className="card-title">
                <span className="ic-wrap">💼</span> Refer & Account
              </div>
              <div className="income-grid">
                <div className="income-card">
                  <div
                    className="ic"
                    style={{background: "rgba(240, 180, 41, 0.14)", color: "var(--accent-gold)"}}
                  >
                    🏗️
                  </div>
                  <div>
                    <div className="lbl">My Referer</div>
                    <div style={{wordBreak:"break-all",fontSize:"0.8rem"}} className="amt"> {refer}</div>
                  </div>
                </div>
                <div className="income-card">
                  <div
                    className="ic"
                    style={{background: "rgba(239, 69, 80, 0.14)", color: "var(--accent-red)"}}
                  >
                    🕸️
                  </div>
                  <div>
                    <div  className="lbl">My Referlink</div>
                    <div style={{wordBreak:"break-all",fontSize:"0.8rem"}} className="amt">{referlink} </div>
                  </div>
                </div>
                <div className="income-card">
                  <div
                    className="ic"
                    style={{background: "rgba(91, 124, 250, 0.14)", color: "var(--accent-blue)"}}
                  >
                    💼
                  </div>
                  <div>
                    <div className="lbl"> My Account</div>
                    <div style={{wordBreak:"break-all",fontSize:"0.8rem"}} className="amt">{account}</div>
                  </div>
                </div>
                
              </div>
            </div>
         
            {/* Recent activities */}
            <div className="card">
  <div className="card-title">
    <span className="ic-wrap">✨</span> Platform Features
  </div>

  <div className="activity">
    <div className="ic">💰</div>
    <div>
      <h4>Daily Profit Sharing</h4>
      <p>
        Earn daily profit sharing rewards based on your active package and
        platform performance.
      </p>
    </div>
  </div>

  <div className="activity">
    <div className="ic">👥</div>
    <div>
      <h4>Team Building Rewards</h4>
      <p>
        Grow your network and receive direct, level, and leadership bonuses
        from your team activities.
      </p>
    </div>
  </div>

  <div className="activity">
    <div className="ic">⚡</div>
    <div>
      <h4>Instant Withdrawals</h4>
      <p>
        Request withdrawals anytime and receive payouts directly to your
        wallet with fast processing.
      </p>
    </div>
  </div>

  
</div>
            {/* About Section */}
            <div className="card span-full about-section">
              <div className="card-title">
                <span
                  className="ic-wrap"
                  style={{background: "rgba(91, 124, 250, 0.15)", color: "var(--accent-blue)"}}
                  >ℹ️</span
                >
                About GLOBAL EMPIRE
              </div>
              <div className="about-grid">
                <div className="about-col">
                  <h3>🔒 Transparent & Trustless</h3>
                  <p>
                    The GLOBAL EMPIRE platform offers a wide range of benefits
                    designed to empower individuals in the digital economy.
                    Unlike traditional systems, GLOBAL EMPIRE eliminates the
                    need for intermediaries, allowing users to interact directly
                    within a transparent and secure environment. Every
                    transaction is recorded and verifiable, ensuring complete
                    trust among participants.
                  </p>
                </div>
                
                <div className="about-col">
                  <h3>🚀 Fast, Secure & Rewarding</h3>
                  <p>
                    The platform also provides multiple earning opportunities,
                    making it suitable for both beginners and experienced users.
                    With its fast and secure system, GLOBAL EMPIRE ensures that
                    users can focus on growth without worrying about delays or
                    risks.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <footer className="page-foot">
            © 2026 Global Empire. All rights reserved.
          </footer>
        </div>
      </div>
      </div>

  


   </div> 
  );
}

export default App;
